import React from 'react';
import { useTranslation } from 'react-i18next';
import * as moment from 'moment';
import { FaMaxcdn } from "react-icons/fa6";
import { SiSinglestore } from "react-icons/si";

const Card = ({ data }) => {
  const { t } = useTranslation();
  const isWin = data?.status === "Win";

  return (
    <div className="relative bg-white/80 backdrop-blur-sm rounded-2xl p-4 border border-[#228B22]/20 shadow-lg hover:shadow-xl transition-all duration-200 font-myanmarSansPro overflow-hidden mb-1">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#228B22]/5 to-emerald-500/5 rounded-2xl"></div>

      {/* Header */}
      <div className="relative flex justify-between items-center mb-2">
        <div className="flex items-center gap-3">
          {data.gamblingTypeId === 2 ? (
            <div className="w-8 h-8 bg-[#FFD700] rounded-full flex items-center justify-center">
              <FaMaxcdn size={18} className="text-gray-900" />
            </div>
          ) : (
            <div className="w-8 h-8 bg-[#228B22] rounded-full flex items-center justify-center">
              <SiSinglestore size={18} className="text-white" />
            </div>
          )}
          <div>
            <h3 className="text-[#228B22] font-bold text-lg">
              {data?.gamblingTypeId === 1 ? t("body") : t("maungg")}
            </h3>
            <div className="flex items-center">
              <div className="w-2 h-2 bg-[#FFD700] rounded-full mr-2"></div>
              <span className="text-xs text-gray-600 font-medium">Betting History</span>
            </div>
          </div>
        </div>
        <div className="text-right">
          <p className="text-xs text-gray-500 font-dangrek">
            {moment(data?.createdDate).format('DD.MM.YYYY')}
          </p>
          <p className="text-xs text-gray-500 font-dangrek">
            {moment(data?.createdDate).format('h:mm A')}
          </p>
        </div>
      </div>

      {/* Info Cards */}
      <div className="relative bg-white/70 rounded-xl px-4 py-3 space-y-1 border border-[#228B22]/10 mb-2">
        <div className="flex justify-between items-center">
          <span className="font-semibold text-gray-700 flex items-center">
            <span className="w-2 h-2 bg-[#228B22] rounded-full mr-2"></span>
            {t("betAmount")}:
          </span>
          <span className="font-dangrek font-bold text-[#1E90FF]">{parseInt(data?.amount).toLocaleString()}</span>
        </div>

        {data?.gamblingTypeId === 2 && (
          <div className="flex justify-between items-center">
            <span className="font-semibold text-gray-700 flex items-center">
              <span className="w-2 h-2 bg-[#FFD700] rounded-full mr-2"></span>
              {t("teamCount")}:
            </span>
            <span className="font-dangrek font-bold text-gray-900">{data?.teamCount}</span>
          </div>
        )}

        <div className="flex justify-between items-center">
          <span className="font-semibold text-gray-700 flex items-center">
            <span className="w-2 h-2 bg-[#FF4500] rounded-full mr-2"></span>
            {t("profitAmount")}:
          </span>
          <span className="font-dangrek font-bold text-[#228B22]">
            {data?.profitAmount < 0 ? "0" : parseInt(data?.profitAmount).toLocaleString()}
          </span>
        </div>
      </div>

      {/* Status Badge */}
      <div className="relative flex justify-end">
        <div className={`inline-flex items-center px-4 py-2 rounded-full font-bold text-sm shadow-lg ${
          isWin
            ? 'bg-gradient-to-r from-green-500 to-emerald-600 text-white'
            : 'bg-gradient-to-r from-red-500 to-red-600 text-white'
        }`}>
          <div className={`w-2 h-2 rounded-full mr-2 ${isWin ? 'bg-white' : 'bg-white'} animate-pulse`}></div>
          {data?.status}
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute -top-1 -right-1 w-4 h-4 bg-gradient-to-r from-[#FFD700] to-yellow-400 rounded-full shadow-lg animate-pulse"></div>
      <div className="absolute -bottom-1 -left-1 w-3 h-3 bg-gradient-to-r from-[#228B22] to-emerald-600 rounded-full shadow-lg animate-pulse" style={{ animationDelay: '1s' }}></div>
    </div>
  );
};

export default Card;
